if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.checkLabelWidths();

      // Re-check on resize for mobile/desktop transitions
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.checkLabelWidths(), 100);
      });
    }

    checkLabelWidths() {
      // Only apply on mobile (< 750px)
      if (window.innerWidth >= 750) {
        this.querySelectorAll('.product-form__input--dropdown').forEach(dropdown => {
          dropdown.classList.remove('label-wide');
        });
        return;
      }

      this.querySelectorAll('.product-form__input--dropdown').forEach(dropdown => {
        const label = dropdown.querySelector('.form__label');
        if (!label) return;

        // Check if label width exceeds 4em
        const labelWidth = label.offsetWidth;
        const fourEm = parseFloat(getComputedStyle(label).fontSize) * 4;

        if (labelWidth > fourEm) {
          dropdown.classList.add('label-wide');
        } else {
          dropdown.classList.remove('label-wide');
        }
      });
    }
  });
}
